module.exports = __webpack_public_path__ + "static/media/maestro_logo_dark.7fa9ad58.svg";